import { render, staticRenderFns } from "./_activeConsult.vue?vue&type=template&id=f4df53ca&scoped=true"
import script from "./_activeConsult.vue?vue&type=script&lang=js"
export * from "./_activeConsult.vue?vue&type=script&lang=js"
import style0 from "./_activeConsult.vue?vue&type=style&index=0&id=f4df53ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4df53ca",
  null
  
)

export default component.exports